module.exports = __webpack_public_path__ + "img/xero.6e06866d.svg";